import { useUserProfileDetailCardQuery } from 'generated/graphql';
import React from 'react';

export interface IData {
  apiFileId: string;
  url: string;
}

export function useQuery() {
  const tuple = useUserProfileDetailCardQuery({
    variables: {
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        apiFileId: tuple.data?.loggedInUser?.person?.profilePicture?.id ?? '',
        url: tuple.data?.loggedInUser?.person?.profilePicture?.url ?? ''
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
